import { useEffect, useRef } from 'react';

const CALENDLY_SCRIPT_SRC = 'https://assets.calendly.com/assets/external/widget.js';

function loadCalendlyScript() {
  if (window.Calendly) return Promise.resolve();
  const existing = document.querySelector(`script[src="${CALENDLY_SCRIPT_SRC}"]`);
  if (existing) {
    return new Promise((resolve) => {
      if (window.Calendly) return resolve();
      existing.addEventListener('load', () => resolve(), { once: true });
    });
  }
  return new Promise((resolve) => {
    const script = document.createElement('script');
    script.src = CALENDLY_SCRIPT_SRC;
    script.async = true;
    script.onload = () => resolve();
    document.head.appendChild(script);
  });
}

export default function CalendlyEmbed({ calendlyUrl, clientName, clientEmail, height }) {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    let cancelled = false;
    const base = calendlyUrl || 'https://calendly.com/lucas-restohost-vk1k/discover-restohost-ai';
    const sep = base.includes('?') ? '&' : '?';
    const url = `${base}${sep}hide_event_type_details=1&hide_gdpr_banner=1`;

    container.innerHTML = '';

    loadCalendlyScript().then(() => {
      if (cancelled || !window.Calendly || !containerRef.current) return;
      if (containerRef.current.childElementCount > 0) return;

      const prefill = {};
      if (clientName && clientName !== 'Restaurant Name') prefill.name = clientName;
      if (clientEmail) prefill.email = clientEmail;

      window.Calendly.initInlineWidget({
        url,
        parentElement: containerRef.current,
        prefill,
      });
    });

    return () => {
      cancelled = true;
      if (container) container.innerHTML = '';
    };
  }, [calendlyUrl, clientName, clientEmail]);

  return (
    <div
      ref={containerRef}
      style={{
        width: '100%',
        height: height || 'clamp(600px, calc(100dvh - 260px), 900px)',
        borderRadius: 14,
      }}
    />
  );
}
